import React, { Component } from 'react'
import Map from './Core'
export default class Maps extends Component {

    callbackLoaded = () => {}
    
    map() {
        Map((google) => {
            this.googleMaps = google.maps
            this.initMap()
        })
    }

    componentWillMount() {
        this.mounted = true
        this.map()
    }

    initMap(retry = true) {
        let googleMaps = this.googleMaps
        let lat = this.props.lat || 0
        let lng = this.props.lng || 0

        let mapCoordinates = {lat, lng}
        let element = this.refMap

        if(!element) {
            if(retry) {
                setTimeout(() => this.initMap(false), 1000)
            }
            return
        } 
        
        this.map = new googleMaps.Map(element, {
            zoom: 7,
            center: mapCoordinates,
            disableDefaultUI: true,
            disableDoubleClickZoom: true,
            draggable: true,
            draggableCursor: true,
            mapTypeControl: true,
            fullscreenControl: true,
            panControl: true,
            scaleControl: true,
            streetViewControl: true,
            zoomControl: true,
            mapTypeId: 'roadmap'
        })


        this.callbackLoaded()
        
    }

    handleLoad( callback ) {
        this.callbackLoaded = callback
    }

    KmlLayer( url ) {
        new this.googleMaps.KmlLayer({
            url,
            map: this.map
        })
    }



    render() {
        return (
            <div ref={ref => this.refMap = ref} style={{height: this.props.height || '300px', width: '100%', position: 'static'}}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/third-party/GoogleMap/LoadMap.js